/**
 *
 */
var Extensions = /** @class */ (function () {
    function Extensions() {
    }
    Extensions.SIMD = Boolean(typeof (SIMD) !== 'undefined');
    return Extensions;
}());
export { Extensions };
